import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  BooleanInput,
  required,
  ResourceContextProvider,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

export const BoardCreate = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          component="button"
          onClick={() => navigate('/boards')}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            border: '1px solid #ddd',
            borderRadius: 1,
            px: 2,
            py: 1,
            bgcolor: 'background.paper',
            cursor: 'pointer',
            '&:hover': {
              bgcolor: 'grey.100',
            },
            transition: 'all 0.2s ease',
          }}
        >
          <ArrowBackIcon fontSize="small" />
          <Typography variant="body2">Back to Boards</Typography>
        </Box>
      </Box>

      <ResourceContextProvider value="boards">
        <Create redirect="list">
          <SimpleForm>
            <TextInput source="name" label="Name" validate={required()} fullWidth />
            <TextInput source="description" label="Description" multiline rows={2} fullWidth />
            <SelectInput
              source="type"
              label="Type"
              choices={[
                { id: 'Sales', name: 'Sales' },
                { id: 'Projects', name: 'Projects' },
                { id: 'Leads', name: 'Leads' },
                { id: 'Custom', name: 'Custom' },
              ]}
              validate={required()}
              fullWidth
            />
            <BooleanInput source="isActive" label="Active" defaultValue={true} />
            <BooleanInput source="allowMultipleAssignees" label="Allow Multiple Assignees" />
            <BooleanInput source="requireDueDates" label="Require Due Dates" />
            <BooleanInput source="enableNotifications" label="Enable Notifications" />
            <BooleanInput source="archiveCompletedItems" label="Archive Completed Items" />
          </SimpleForm>
        </Create>
      </ResourceContextProvider>
    </Box>
  );
};
